const SPEND_STATUS_OPTIONS = [
   {
      value: 'live',
      label: 'Live',
      id: 'live',
      name: 'Live',
   },
   {
      value: 'capped',
      label: 'Capped',
      id: 'capped',
      name: 'Capped',
   },
   {
      value: 'warning',
      label: 'Warning',
      id: 'warning',
      name: 'Warning',
   },
];

export default SPEND_STATUS_OPTIONS;
